function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".frame,.primary{fill:none;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}.primary-fill{fill:#4f4954;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "frame",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("rect", {
  className: "highlights",
  x: 112,
  y: 176,
  width: 104,
  height: 56
}), React.createElement("rect", {
  className: "highlights",
  x: 40,
  y: 176,
  width: 72,
  height: 56
})), React.createElement("g", {
  id: "primary"
}, React.createElement("path", {
  className: "primary",
  d: "M124,24h92a0,0,0,0,1,0,0V220a12,12,0,0,1-12,12H124a12,12,0,0,1-12-12V36A12,12,0,0,1,124,24Z",
  transform: "translate(328 256) rotate(180)"
}), React.createElement("path", {
  className: "primary",
  d: "M40.6,89.49H112a0,0,0,0,1,0,0V220a12,12,0,0,1-12,12H52.6a12,12,0,0,1-12-12V89.49A0,0,0,0,1,40.6,89.49Z",
  transform: "translate(152.6 321.49) rotate(180)"
}), React.createElement("circle", {
  className: "primary-fill",
  cx: 164,
  cy: 92,
  r: 12
}), React.createElement("circle", {
  className: "primary-fill",
  cx: 164,
  cy: 148,
  r: 12
}), React.createElement("path", {
  className: "primary-fill",
  d: "M152,192h24a0,0,0,0,1,0,0v36a12,12,0,0,1-12,12h0a12,12,0,0,1-12-12V192A0,0,0,0,1,152,192Z",
  transform: "translate(328 432) rotate(180)"
})));
var SvgBusiness = function SvgBusiness(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBusiness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Business.ca138561.svg";
export { ForwardRef as ReactComponent };